import { motion } from "framer-motion";
import { CAPABILITIES } from "@/lib/content";
import { SectionLabel, RevealLines, EASE } from "../site/motion";
import { Symbol } from "../site/Logo";

const SPANS = [
  "lg:col-span-7 lg:row-span-2",
  "lg:col-span-5",
  "lg:col-span-5",
  "lg:col-span-4",
  "lg:col-span-4",
  "lg:col-span-4",
];

const Tile = ({ c, i }) => {
  const big = i === 0;
  return (
    <motion.article
      data-testid={`bento-${c.key}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay: (i % 3) * 0.08 }}
      className={`group relative flex min-h-[260px] flex-col justify-between overflow-hidden rounded-[22px] border border-cream/10 bg-skaris-card p-7 transition-colors duration-500 hover:border-skaris-sky/50 ${SPANS[i]}`}
    >
      <img src={c.tile || c.img} alt={c.title} loading="lazy" className={`duotone absolute inset-0 h-full w-full object-cover transition-[transform,opacity] duration-[1.4s] ease-[cubic-bezier(.16,1,.3,1)] group-hover:scale-105 ${big ? "opacity-60" : "opacity-70 group-hover:opacity-85"}`} />
      <div className={`absolute inset-0 bg-gradient-to-t from-skaris-ink ${big ? "via-skaris-ink/70 to-transparent" : "via-skaris-ink/75 to-transparent"}`} />
      {!big && <div className="tile-glow pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />}
      <div className="relative flex items-start justify-between">
        <span className="font-mono text-xs text-skaris-sky">{c.n}</span>
        <Symbol className="h-5 w-auto text-cream/25 transition-[color,transform] duration-500 group-hover:rotate-[60deg] group-hover:text-skaris-sky" />
      </div>
      <div className="relative mt-10">
        <h3 className={`font-display font-semibold leading-tight tracking-tight text-cream ${big ? "text-3xl md:text-5xl" : "text-2xl"}`}>{c.title}</h3>
        <p className={`mt-3 font-body text-sm leading-relaxed text-cream/75 ${big ? "max-w-lg md:text-base" : ""}`}>{c.body}</p>
      </div>
    </motion.article>
  );
};

export const Bento = () => (
  <section data-testid="capabilities-section" className="relative py-24 md:py-32">
    <div className="mx-auto max-w-[1440px] px-6 md:px-10">
      <SectionLabel n="(03)">Core capabilities</SectionLabel>
      <RevealLines inView as="h2" lines={["Capabilities", "engineered in\u2011house."]}
        className="mt-6 font-display text-4xl font-semibold uppercase leading-[0.95] tracking-[-0.03em] text-cream sm:text-5xl lg:text-7xl"
        lineClass={(i) => (i === 1 ? "text-gradient" : "")} />
      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2 lg:auto-rows-[280px] lg:grid-cols-12">
        {CAPABILITIES.map((c, i) => <Tile key={c.key} c={c} i={i} />)}
      </div>
    </div>
  </section>
);
